import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import fact from "../../Assets/Projects/fact.jpeg";
import bitsOfCode from "../../Assets/Projects/bit.jpeg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          From Voice AI products to enterprise GenAI pipelines — here's what
          I've been building.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={12} className="project-card">
            <ProjectCard
              featured={true}
              isBlog={false}
              title="Voycee – AI Voice Assistance Platform"
              description="Built end-to-end — a production Voice AI system that automates inbound calls for restaurants and hospitals. Handles reservations, appointment booking, order status checks, department routing, and general FAQs. Supports English and Spanish with a real-time analytics dashboard. During testing, missed calls during peak hours dropped by ~80%."
              keywords="Python 3.10 | FastAPI | React 18 | Voice AI | Conversational AI"
              liveLink="https://voycee.com"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              isBlog={false}
              title="TeamCal AI – Intelligent Scheduling"
              description="AI-powered scheduling platform using LangChain and GPT-4 to automate meeting coordination. Features NLP for scheduling requests, conflict resolution across time zones, and RAG architecture. Shipped to real enterprise customers."
              keywords="LangChain | OpenAI GPT-4 | Spring Boot 3.x | React 18 | GraphQL | AWS"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fact}
              isBlog={false}
              title="FactFinder – Fake News Detection"
              description="Full-stack ML classification app handling 7,000+ concurrent users with a real-time prediction API. Uses machine learning and deep learning to discern genuine from deceptive information."
              keywords="Python | Flask | React.js | Firebase | ML | AWS ECS"
              ghLink="https://github.com/Saitata7/2024S-JusticeLeague"
              demoLink="https://main--factfinder.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Business Website"
              description="A modern, responsive business template built with React. Customizable with your content and branding to make it unique to your business."
              keywords="React.js | Node.js | Bootstrap"
              ghLink="https://github.com/Saitata7/business-web-site"
              demoLink="https://candid-syrniki-9cb004.netlify.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              isBlog={false}
              title="Wazrix-bot – Trading Algorithm"
              description="AI-powered trading algorithm for WazirX. Leverages real-time market data and intelligent predictions to buy low and sell high."
              keywords="Python | Flask | JavaScript"
              ghLink="https://github.com/Saitata7/wbot"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              isBlog={false}
              title="Java gRPC & GraphQL Microservices"
              description="High-performance microservices using gRPC for inter-service communication and GraphQL API layer. Built for trading platform with sub-100ms latency."
              keywords="Java | Spring Boot | gRPC | GraphQL | PostgreSQL | Redis"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              isBlog={false}
              title="Blog Book"
              description="Full-featured blogging platform where you can create and manage your own blog, publish posts, and gain visibility among blog categories."
              keywords="PHP | CodeIgniter | JavaScript | MySQL"
              ghLink="https://github.com/Saitata7/blogBook"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              isBlog={false}
              title="OAuth 2.0 Spring Boot"
              description="Secure client application authorization with OAuth 2.0 in Spring Boot. Implements CRUD operations for seamless data management."
              keywords="Java | Spring Boot | MySQL | Postman"
              ghLink="https://github.com/Saitata7/oauth"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              isBlog={false}
              title="Custom Clothing E-Commerce"
              description="Full-stack e-commerce platform for clothing design with user authentication, payment gateway, inventory management, and order processing. Deployed on AWS."
              keywords="React.js | PHP | MySQL | AWS | Payment Gateway"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              isBlog={false}
              title="Object Detection – TensorFlow"
              description="Object detection using TensorFlow with CNNs for autonomous driving, security surveillance, and real-time object tracking."
              keywords="Python | TensorFlow | OpenCV | Machine Learning"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
